import { Toaster as Sonner, toast } from "sonner"
import { useTheme } from "@/hooks/use-theme"

/**
 * Themed Sonner toaster. Uses the app's `use-theme` hook so toasts match
 * light/dark mode.
 *
 * Error variant is intentionally subtle — same card background as success,
 * with a destructive LEFT BORDER + destructive icon/title, body text stays in
 * the normal foreground color. This avoids the loud-red-block look while
 * keeping the error scannable.
 */
const Toaster = ({ ...props }) => {
  const { theme = "light" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:shadow-elevated " +
            // Error: card bg, foreground text, red left border + red icon
            "data-[type=error]:!border-l-4 data-[type=error]:!border-l-destructive " +
            "data-[type=error]:[&_[data-icon]]:text-destructive " +
            // Success: subtle green left border
            "data-[type=success]:!border-l-4 data-[type=success]:!border-l-success " +
            "data-[type=success]:[&_[data-icon]]:text-success " +
            // Warning: subtle gold left border
            "data-[type=warning]:!border-l-4 data-[type=warning]:!border-l-gold " +
            "data-[type=warning]:[&_[data-icon]]:text-gold",
          title:
            "font-medium text-sm " +
            "group-data-[type=error]:text-destructive",
          description: "group-[.toast]:text-muted-foreground text-xs leading-relaxed",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "group-[.toast]:bg-card group-[.toast]:border-border group-[.toast]:text-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
